module.exports = __webpack_public_path__ + "static/media/ThisWaytoHappy_jacket.953a293e.jpg";